import { render, staticRenderFns } from "./DetailReportTable.vue?vue&type=template&id=2afe01fc&scoped=true&"
import script from "./DetailReportTable.vue?vue&type=script&lang=js&"
export * from "./DetailReportTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailReportTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DetailReportTable.vue?vue&type=style&index=1&id=2afe01fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe01fc",
  null
  
)

export default component.exports